<span [hidden]="!loading"> <ab-spinner-inline></ab-spinner-inline></span>
<div class="integration-error" *ngIf="error">
  <b>{{ error.error }}:&nbsp;</b>{{ error.errorMessage }}.<br /><a
    href="/projects/{{ notice.projectId }}/services/8"
    target="_self"
    >Check your settings</a
  >
</div>
<button
  class="btn btn-holder"
  *ngIf="!ticket?.url && !error && !loading"
  (click)="createTicket()"
  [disabled]="creatingTicket"
  type="button"
>
  <span *ngIf="!creatingTicket"
    ><i
      class="glyphicon glyphicon-ab-integrations-assembla glyphicon--valign-baseline"
    ></i
    >&nbsp; Create Assembla ticket</span
  ><span [hidden]="!creatingTicket">
    <ab-spinner-inline></ab-spinner-inline>Creating Assembla ticket</span
  >
</button>
<div *ngIf="ticket?.url">
  <i
    class="glyphicon glyphicon-ab-integrations-assembla glyphicon--valign-baseline"
  ></i
  >&nbsp;<ab-external-link *ngIf="ticket.url" href="{{ ticket.url }}"
    >View on Assembla</ab-external-link
  >&nbsp;
  <button
    class="btn btn-holder btn--reduced-padding"
    *ngIf="ticket.url && !error"
    (click)="removeTicket()"
    [disabled]="removingTicket"
    type="button"
  >
    <span *ngIf="!removingTicket">Remove</span
    ><span [hidden]="!removingTicket">
      <ab-spinner-inline></ab-spinner-inline>Removing</span
    >
  </button>
</div>
